import { useDebounce } from '@uidotdev/usehooks';
import { FC, useState } from 'react';

import { Option } from '@components/ui/autocomplete/auto-complete-input';
import { ResetFilterButton } from '@components/ui/button';
import {
    AutoCompleteFilter,
    TextSearchFilter,
} from '@components/ui/search-filter';

import { UrlSearchFilterProperty } from '@/constants';
import { useGetBrandsQuery } from '@/features/slice/products/brand/brand-api-slice';
import { useUrlFilter } from '@/hooks';

type StockListFiltersProps = {
    searchPlaceholder: string;
};

export const StockListFilters: FC<StockListFiltersProps> = ({
    searchPlaceholder,
}) => {
    const { setSearchText, setSearchFilter, getSearchFilter, searchText } =
        useUrlFilter();

    const brandNameFilter =
        getSearchFilter(UrlSearchFilterProperty.BRAND_NAME) || '';
    const brandIdFilter =
        getSearchFilter(UrlSearchFilterProperty.BRAND_ID) || '';

    const [brandSearchText, setBrandSearchText] = useState('');

    const debouncedBrandSearchText = useDebounce(brandSearchText, 500);

    const {
        data: brandsData,
        isLoading: isBrandsLoading,
        isFetching: isBrandsFetching,
    } = useGetBrandsQuery({
        search: debouncedBrandSearchText,
    });

    const handleSelectBrand = (selectedValue: Option) => {
        setSearchFilter(UrlSearchFilterProperty.BRAND_ID, selectedValue.value);
        setSearchFilter(
            UrlSearchFilterProperty.BRAND_NAME,
            selectedValue.label,
        );
    };

    // TODO: Need to add type later
    const brands = brandsData?.data?.map((brand: any) => ({
        label: brand.name,
        value: brand.id,
    }));

    const brandValue = {
        label: brandNameFilter,
        value: brandIdFilter,
    };

    return (
        <div className="flex flex-col flex-wrap items-center justify-start gap-2 sm:flex-row sm:items-center">
            <TextSearchFilter
                onChangeSearch={(e) => setSearchText(e.target.value)}
                placeholder={searchPlaceholder}
                value={searchText}
            />

            <AutoCompleteFilter
                options={brands ?? []}
                value={brandValue}
                onValueChange={handleSelectBrand}
                placeholder="Select brand"
                isLoading={isBrandsLoading || isBrandsFetching}
                onInputChange={(value) => setBrandSearchText(value)}
            />

            <ResetFilterButton />
        </div>
    );
};

StockListFilters.displayName = 'StockListFilters';
